export const STEPS = {
  INITIAL: 1,
  AMOUNT_CONFIRM: 2,
  CONFIRM: 3,
  PROCESSING: 4,
  FINISHED_SUCCESS: 5,
  FINISHED_FAILED: 6,
  FINISHED_EXPIRED: 7,
};

export const FINISHED_STATUS = {
  SUCCESS: 1,
  FAILED: 2,
  EXPIRED: 3,
};



// WEBPACK FOOTER //
// ./src/components/wallet/add-funds-bank-transfer/add-funds-bank-transfer-constants.js